import React from 'react';
import { Container } from '../ui/Container';
import { getImagePath } from '../../Utils/Utilities';
import { useBrand } from '../../Utils/BrandContext';

const SupportDesktopSection = () => {
  const sectionRef = React.useRef(null);
    const { brand: activeBrand } = useBrand();
  const supportFeatures = [
    {
      icon: (
        <svg className="w-9 h-9" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Mon to Sun',
      description: 'All week long support access.'
    },
    {
      icon: (
        <svg className="w-9 h-9" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Live Training',
      description: 'Interactive live training sessions to solve doubts.'
    },
    {
      icon: (
        <svg className="w-9 h-9" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
        </svg>
      ),
      title: 'Ticketing',
      description: 'Effortless ticketing system for customer issues.'
    },
    {
      icon: (
        <svg className="w-9 h-9" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      title: 'Tutorials',
      description: 'Downloadable tutorials & PDFs for learning.'
    }
  ];

  return (
    <>

      <section ref={sectionRef} id="premium-support" className="md:block hidden bg-white pb-12 md:pb-20 pt-12 md:pt-12 mt-[-30px]">
        <Container> 
          {/* Header */}
          <div className="text-center mb-8">
            <h2 className="text-[30px] md:text-[40px] font-bold secttl mb-3">
              Free Support
            </h2>
            {/* <p className="text-[14px] md:text-lg text-text-primary max-w-xl mx-auto px-4">
              Our Customer Success team takes pride in our prompt service to help you maximize your benefits from {activeBrand === 'bz' ? 'Biziverse' : 'QikERP'}!
            </p> */}
          </div>

          {/* Support Cards Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-6xl mx-auto">
            {supportFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-background-light rounded p-5 flex flex-col items-start border border-border"
              >
                <div className="text-primary mb-2.5">
                  {feature.icon}
                </div>
                <h4 className="text-base md:text-lg font-bold text-text-primary mb-1.5">
                  {feature.title}
                </h4>
                <p className="text-xs md:text-sm text-text-primary leading-snug">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default SupportDesktopSection;